<div class="segmented-progress-bar" role="list" aria-label="Fortschritt">
  @for (step of steps(); track step; let last = $last; let stepIndex = $index) {
    <div
      class="segment"
      role="listitem"
      [class.completed]="isCompleted(stepIndex)"
      [class.open]="!isCompleted(stepIndex)"
    >
      <div class="circle">
        @if (isCompleted(stepIndex)) {
          <ui-icon faName="check" faStyle="solid"></ui-icon>
        }
      </div>
      <span class="label">{{ label(step) }}</span>
    </div>

    @if (!last) {
      <div class="line"></div>
    }
  }
</div>
